export default "__VITE_ASSET__DwyPcoj8__"